import { deleteProject as deleteProjectAPI } from '@services/project';
import { useProjectStore } from '@stores/project';
import { useRecentProjectStore } from '@stores/recentProject';
import { Message } from '@wegic/ui';
import '@wegic/ui/dist/components/Message/index.css';
import { formatRelativeTime } from '@/helpers/formatTime';
import { useSubscriptionEndAndCancel } from '@/modules/Subscribe/helper';
import { DAY_7_INTERVAL } from './const';
/**
 * 获取弹出容器
 */ export function getPopupContainer() {
    return document.querySelector('#panel-container-viewport') ?? document.body;
}
/**
 * 删除项目
 */ export async function deleteProject(project) {
    try {
        await deleteProjectAPI(project.id);
        Message.success(intl.get('workspace.moveToTrash.success'));
        // 刷新项目列表
        const { projectList, setProjectList } = useProjectStore.getState();
        const updatedList = projectList.filter((p)=>p.id !== project.id);
        setProjectList(updatedList);
        useRecentProjectStore.getState().removeRecentProject(project.id);
    } catch (error) {
        console.error('Failed to move project to trash:', error);
        Message.error(intl.get('workspace.moveToTrash.error', {
            error: error instanceof Error ? error.message : String(error)
        }));
        throw error;
    }
}
/** 自定义域名权益到期提醒 */ export function useCustomDomainRemind(userSubscription, isCustomDomain) {
    return useSubscriptionEndAndCancel(userSubscription, DAY_7_INTERVAL) && isCustomDomain;
}
export function formatProjectLastActive(project) {
    const time = formatRelativeTime(project.lastActiveAt || project.updatedAt || project.createdAt);
    return intl.get('workspace.projectCard.lastActive', {
        time
    });
}
